export default __webpack_public_path__ + "static/media/wave.47397b27.svg";